export const downloadFile = (data: string, fileName: string, extension?: string) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", fileName + (extension ? (extension as string) : ""))
  document.body.appendChild(link)
  link.click()
}
